import PageContainer from '~/shared/components/PageContainer';
import { RoleArn } from './components/RoleArn';

export default function PermissionsPage() {

  return (
    <PageContainer className="px-[30px]">
      {/* {isOrganizationAccount ? (
        <RoleArnOrganization />
      ) : (
        <RoleArn />
      )} */}
      <RoleArn />
    </PageContainer>
  );
}
